/**
 * @flow
 *
 * @format
 */
import BaseItem, { ItemTypes } from './BaseItem';

/* ***************************
  CLASS
*************************** */
export type AppStart = {};

export default class StartItem extends BaseItem {
  constructor(json: any) {
    if (json instanceof StartItem) {
      super(json, true);
    } else {
      super(json, false);
    }
    const { type, meta, ...newMeta } = json;
    this.type = ItemTypes.Start;
    this.setMeta({ ...json.meta, ...newMeta });
  }
}
